/* eslint-disable react/display-name */
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"

export interface MarkdownReaderProps {
  children: string
  className?: string
}

function MarkdownReader({ children, className = "" }: MarkdownReaderProps) {
  return (
    <ReactMarkdown className={`markdown-reader ${className}`} rehypePlugins={[rehypeRaw]}>
      {children}
    </ReactMarkdown>
  )
}

export default MarkdownReader
